export default __webpack_public_path__ + "static/media/graham.8657f109.jpeg";